const env = import.meta.env

export default {
    baseURL: env.VITE_API_BASE_URL,
    imgUrl: env.VITE_API_IMG_URL,
}
